import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/shipin-fuwu' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide transition-colors duration-300 ${
              isScrolled ? 'text-primary-600' : 'text-white'
            }`}>
              久久在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer group ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-white/90 hover:text-white'
                } ${
                  location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href))
                    ? isScrolled ? 'text-primary-600' : 'text-white'
                    : ''
                }`}
              >
                {link.label}
                <span className={`absolute -bottom-1 left-0 h-0.5 transition-all duration-200 ${
                  location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href))
                    ? 'w-full ' + (isScrolled ? 'bg-primary-500' : 'bg-white')
                    : 'w-0 group-hover:w-full ' + (isScrolled ? 'bg-primary-500' : 'bg-white')
                }`}></span>
              </Link>
            ))}
            <a
              href="#"
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              免费注册
            </a>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href))
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#"
              className="px-4 py-3 rounded-lg text-sm font-medium bg-primary-500 text-background-50 text-center cursor-pointer hover:bg-primary-600 transition-colors"
            >
              免费注册
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}